import { Divider } from "antd";
import React from "react";
import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import BasicDialog from "../../../../core/BasicDialog";
import KnowledgeSourceLookup from "../../../Lookups/KnowledgeSourceLookup";
import EditableLink from "../../../../core/EditableLink";
import SubmitButton from "../../../../core/SubmitButton/SubmitButton";

const KnowledgeSource = ({
  knowledgeSourceClassifications,
  onChange,
  knowledgeSource,
  editable,
  maxLength,
  handleShow,
  handleClose,
  onSave,
  show,
  onNewKnowledgeSourceChange,
  newKnowledgeSource,
  validationRules,
  disabled,
  messageHandler
}) => {
  const inputFields = () => {
    const inputFields = [
      {
        label: labels.uri,
        controlId: "uri",
        placeholder: labels.uriPlaceholder,
        type: "link"
      },
      {
        label: labels.institution,
        controlId: "institution",
        placeholder: labels.institutionPlaceholder,
        type: "text"
      },
      {
        label: labels.knowledgeSourceClassification,
        controlId: "knowledgeSourceClassification",
        placeholder: labels.knowledgeSourceClassification,
        type: "dropdown",
        dropDownOptions: knowledgeSourceClassifications
      }
    ];
    return inputFields;
  };

  return (
    <>
      <Row>
        <Col sm="3">
          <FormLabel className="Label">
            {labels.selectedKnowledgeSource}
          </FormLabel>
        </Col>
        <Col sm="7">
          <FormGroup>
            <KnowledgeSourceLookup
              onChange={onChange}
              controlId="knowledgeSource"
              selected={knowledgeSource}
              messageHandler={messageHandler}
              placeholder={labels.knowledgeSource}
              readOnly={!editable}
            />
          </FormGroup>
        </Col>
        <Col sm="2">
          <SubmitButton
            type="create"
            size="sm"
            onClick={handleShow}
            disabled={!editable}
          />
        </Col>
      </Row>
      <Divider>{labels.details}</Divider>
      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.name}</FormLabel>
        </Col>
        <Col>
          <FormLabel>{knowledgeSource ? knowledgeSource.name : null}</FormLabel>
        </Col>
      </Row>

      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.description}</FormLabel>
        </Col>
        <Col>
          <FormLabel>
            {knowledgeSource ? knowledgeSource.description : null}
          </FormLabel>
        </Col>
      </Row>

      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.uri}</FormLabel>
        </Col>
        <Col>
          <EditableLink
            title={labels.uri}
            value={knowledgeSource ? knowledgeSource.uri : ""}
            placeholder={labels.uri}
            disabled={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.institution}</FormLabel>
        </Col>
        <Col>
          <FormLabel>
            {knowledgeSource ? knowledgeSource.institution : null}
          </FormLabel>
        </Col>
      </Row>
      <Row>
        <Col sm="2">
          <FormLabel className="Label">
            {labels.knowledgeSourceClassification}
          </FormLabel>
        </Col>
        <Col>
          <FormLabel>
            {knowledgeSource?.knowledgeSourceClassification?.name || null}
          </FormLabel>
        </Col>
      </Row>

      <BasicDialog
        dialogTitle={labels.knowledgeSource}
        show={show}
        handleClose={handleClose}
        entity={newKnowledgeSource}
        maxLength={maxLength}
        onSave={onSave}
        onChange={onNewKnowledgeSourceChange}
        disabled={disabled}
        validationRules={validationRules}
        additionalInputFields={inputFields()}
      />
    </>
  );
};

export default KnowledgeSource;
